// Utils
import { emptyFunction } from "./miscUtils";

export function reformatAcfResponse(res) {
    return Array.isArray(res)
        ? res.map((item) => ({ ...item.acf, id: item.id, tags: item.tags }))
        : { ...res.acf, id: res.id, tags: res.tags };
}

export function get(
    url,
    headers,
    onSuccess = emptyFunction,
    onError = emptyFunction
) {
    return fetch(url, { headers })
        .then(function (response) {
            return response.json().then((res) => {
                if (response.ok) {
                    return onSuccess({ headers: response.headers, body: res });
                } else {
                    return onError(res);
                }
            });
        })
        .catch(function (error) {
            return onError(error);
        });
}
